import { Box, Chip, styled } from '@mui/material';
import CountryImage from '_legacy/components/common/CountryImage';
import {
    NAME_SEPARATOR,
    formatDisplayName,
    getCompanyDisplayName,
} from 'utils/ThirdPartyCompanyFormatter';

const DEFAULT_MAX_LENGTH = 30;

interface IThirdPartyCompanySearchResultProps {
    item: any;
    getItemProps: (callerProps: any) => object;
    highlightedIndex: number;
    index: number;
}

const ThirdPartyCompanySearchResult: React.FC<
    IThirdPartyCompanySearchResultProps
> = ({ item, getItemProps, highlightedIndex, index }) => {
    return (
        <tr
            {...getItemProps({
                item,
                key: item.id,
                style: {
                    backgroundColor:
                        highlightedIndex === index
                            ? 'rgba(0,0,0,0.05)'
                            : 'white',
                },
            })}
        >
            <td title={getCompanyDisplayName(item)}>
                <Box display="flex" alignItems="center">
                    {item.isNonClient && (
                        <StyledIndicator label="Non-KYC" size="small" />
                    )}
                    {renderCompanyName(item)}
                </Box>
            </td>
            <td title={item.parentName}>{truncateText(item.parentName)}</td>
            <td>
                <CountryImage countryCode={item.countryCode} />
            </td>
        </tr>
    );
};

const truncateText = (text, maxLength = DEFAULT_MAX_LENGTH) => {
    return text && text.length > maxLength
        ? text.slice(0, maxLength) + '...'
        : text;
};

const renderCompanyName = (item) => {
    const formattedDisplayName = formatDisplayName(item.displayName);

    if (!formattedDisplayName) {
        return truncateText(item.name);
    }

    const maxLength =
        DEFAULT_MAX_LENGTH -
        formattedDisplayName.length -
        NAME_SEPARATOR.length;

    return (
        <span>
            <b>{formattedDisplayName}</b>
            {NAME_SEPARATOR}
            {truncateText(item.name, maxLength)}
        </span>
    );
};

const StyledIndicator = styled(Chip)({
    width: '53px',
    height: '18px',
    fontSize: '10px',
    fontWeight: 400,
    marginRight: '5px',
    fontFamily: 'Roboto',
    backgroundColor: '#CCD0D1',
    '.MuiChip-label': {
        padding: 0,
    },
});

export default ThirdPartyCompanySearchResult;
